import { selectIsClaimsSidebarContext } from '../sidebar/selectors';
import {
  selectWorklistClaimMessages,
  selectWorklistClaimMessagesLoading,
  selectWorklistClaimUnreadSinceDate,
  selectWorklistClaimRecommendations,
  selectWorklistClaimReminders,
  selectWorklistClaimRemindersLoading,
  selectUpdateWorklistClaimReminderLoading,
  selectDeleteWorklistClaimReminderLoading,
  selectUpdateWorklistClaimMessageLoading,
  selectMessageRecipientOrganizations as selectWorklistClaimMessageRecipientOrganizations,
  selectWorklistClaimReplyRecipientId
} from '../worklistClaims/selectors';
import {
  selectWorklistRiskMessages,
  selectWorklistRiskMessagesLoading,
  selectWorklistRiskUnreadSinceDate,
  selectWorklistRiskRecommendations,
  selectWorklistRiskReminders,
  selectWorklistRiskRemindersLoading,
  selectUpdateWorklistRiskReminderLoading,
  selectDeleteWorklistRiskReminderLoading,
  selectUpdateWorklistRiskMessageLoading,
  selectMessageRecipientOrganizations as selectWorklistRiskMessageRecipientOrganizations,
  selectWorklistRiskReplyRecipientId
} from '../worklistRisks/selectors';
import { selectRisk, selectRiskHistory, selectRiskHistoryLoading } from '../risk/selectors';
import { selectClaim, selectClaimHistory, selectClaimHistoryLoading } from '../claim/selectors';

export const selectGeneralMessagesItemCount = (state) => state.worklists.generalMessagesItemCount;
export const selectWorklistClaimsItemCount = (state) => state.worklists.worklistClaimsItemCount;
export const selectWorklistRisksItemCount = (state) => state.worklists.worklistRisksItemCount;

export const selectWorklistMessages = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectWorklistClaimMessages(state) : selectWorklistRiskMessages(state);
};

export const selectWorklistMessagesLoading = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectWorklistClaimMessagesLoading(state) : selectWorklistRiskMessagesLoading(state);
};

export const selectWorklistUnreadSinceDate = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectWorklistClaimUnreadSinceDate(state) : selectWorklistRiskUnreadSinceDate(state);
};

export const selectWorklistRecommendations = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectWorklistClaimRecommendations(state) : selectWorklistRiskRecommendations(state);
};

export const selectWorklistReminders = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectWorklistClaimReminders(state) : selectWorklistRiskReminders(state);
};

export const selectWorklistRemindersLoading = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectWorklistClaimRemindersLoading(state) : selectWorklistRiskRemindersLoading(state);
};

export const selectUpdateWorklistReminderLoading = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectUpdateWorklistClaimReminderLoading(state) : selectUpdateWorklistRiskReminderLoading(state);
};

export const selectDeleteWorklistReminderLoading = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectDeleteWorklistClaimReminderLoading(state) : selectDeleteWorklistRiskReminderLoading(state);
};

export const selectUpdateWorklistMessageLoading = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectUpdateWorklistClaimMessageLoading(state) : selectUpdateWorklistRiskMessageLoading(state);
};

export const selectWorklistEntityId = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectClaim(state)?.id : selectRisk(state)?.id;
};

export const selectMessageRecipientOrganizations = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims
    ? selectWorklistClaimMessageRecipientOrganizations(state)
    : selectWorklistRiskMessageRecipientOrganizations(state);
};

export const selectWorklistReplyRecipientId = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectWorklistClaimReplyRecipientId(state) : selectWorklistRiskReplyRecipientId(state);
};

export const selectWorklistHistory = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectClaimHistory(state) : selectRiskHistory(state);
};

export const selectWorklistHistoryLoading = (state) => {
  const isClaims = selectIsClaimsSidebarContext(state);
  return isClaims ? selectClaimHistoryLoading(state) : selectRiskHistoryLoading(state);
};
